export const ORDER_DETAILS = {
  URL: '/order',
  TITLE: 'Оформление заказа'
}  

export const PAYMENT = {
  URL: ORDER_DETAILS.URL + '/payment',
  TITLE: "Оплата заказа" 
}

export const ACCEPTED = {
  URL: ORDER_DETAILS.URL + '/accepted',
  TITLE: 'Заказ принят'
}


// WEBPACK FOOTER //
// ./src/features/OrderDetails/links.js